import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Form } from 'components/Form/Form/Form';
import RefereeFormWrapper from 'components/Form/RefereeForm/RefereeFormWrapper';

export const FormPreviewModal = ({ form, visible, useModernForm = false, onClose = () => {} }) => {
  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      title="Preview"
      className="u-margin-y--large"
      fullscreen>
      {visible &&
        (useModernForm ? (
          <div className="h-full max-h-[90vh] mx-auto overflow-y-auto">
            <RefereeFormWrapper
              questions={form?.fields}
              logicJumps={form?.logic_jumps}
              formMessage={form?.message}
              rules={form?.rules}
              disabled={visible}
            />
          </div>
        ) : (
          <div className="h-full w-1/3 mx-auto">
            <Form form={form} buttonTitle="Close" onSubmit={onClose} disabled={visible} />
          </div>
        ))}
    </AnimatedModal>
  );
};
